import * as React from 'react';
import { DropDownListComponent } from '../DropDownList/DropDownListComponent';
import { ItemList } from '../../types/logbook-type';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { customerListV2Data } from '../../types/customer-detail';
import { Thunks } from '../../actions';

export interface Props {
    defaultValue: string;
    organizationId?: string;
    callback: (customerId: string) => void;
}

const CustomerFilterSelect: React.FunctionComponent<Props> = (props) => {

    const { defaultValue, organizationId = '', callback } = props;

    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const customer = useSelector(Selectors.Customer.customer);

    const [customers, setCustomers] = React.useState<ItemList>([]);

    const customerListData = (list: customerListV2Data): ItemList => {
        return list?.map((data, customer) => {
            return {
                id: data.id,
                name: data.companyName,
                number: data.customerNumber
            };
        });
    };

    const handleChange = (customerId: string) => {
        dispatch(Thunks.Asset.getDeviceList(organizationId, '', '', '', '', '', '', customerId));
        callback(customerId);
    }

    React.useEffect(() => {
        if (!customer.customerListLoading && customer.customerListSuccess) {
            setCustomers(customerListData(customer.customerList.customerDetailList));
        }
        else if (!customer.customerListLoading && customer.customerListFail) {
            setCustomers([]);
        }
    }, [customer.customerListLoading, customer.customerListSuccess, customer.customerListFail]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <DropDownListComponent
            disabled={customer.customerListLoading || customers.length === 0}
            data-testid="asset-customer-filter"
            list={customers}
            value={t('SEARCH.ALL_CUSTOMER')}
            handleSelection={handleChange}
            selected={defaultValue}
            defaultSelection={defaultValue}>
        </DropDownListComponent>
    );
};

export default CustomerFilterSelect;
